import { Layouts } from 'react-grid-layout';
import { ViewTicketDetails } from '../../components/Holdings/ViewTicketDetails';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 42,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 32,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    xs: [
        {
            h: 40,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c2',
        },
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        from_date: null,
        to_date: null,
    },
    components: [
        {
            key: 'c1',
            name: 'page-header',
            props: {
                header: {
                    title: 'transactions',
                    path: '',
                },
                rhsComponents: [
                    {
                        name: 'date-range-picker',
                        props: {
                            defaultPeriod: 'all',
                            visiblePeriods: [
                                '1m',
                                '3m',
                                '6m',
                                '1y',
                                'mtd',
                                'qtd',
                                'ytd',
                                'all',
                            ],
                        },
                    },
                ],
            },
        },
        {
            name: 'canopy-table',
            key: 'c2',
            apiDetails: {
                //endpointDomain: 'analytics', //flashdb by default
                //endpointVersion: 'v1',        // v2 by default
                endpoint: `single-line-transactions?`,
                endpointParams: {
                    per_page: '*,per_page',
                    page: '*,page',
                    keyword: 'keyword',
                    parent_user_ids: 'parent_user_id,',
                    from_date: 'from_date',
                    to_date: 'to_date',
                    ccy_account_code: 'ccy_account_code',
                    contract_currency: 'contract_currency',
                    custodian_name: 'custodian_name',
                    child_user_ids: 'child_user_id',
                    trade_type: 'trade_types',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                },
            },
            props: {
                headerText: 'transactions',
                requiredQueryFields: [],
                dataKey: 'transactions',
                title: '',
                showDownloadOn: ['desktop'],
                columns: [
                    {
                        key: 'security_name',
                        otherKeys: ['ticker'],
                        width: 240,
                        type: 'splitCell',
                        headerText: 'ui.mm.table-headers.name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                        actions: [
                            {
                                name: 'ViewTransactions',
                                path: '',
                                Component: <ViewTicketDetails />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                        ],
                    },
                    {
                        key: 'isin',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.isin',
                        canSort: true,
                    },
                    {
                        key: 'ticketref',
                        type: 'text',
                        colSpan: '1',
                        headerText: 'ui.mm.table-headers.ticketref',
                        width: 100,
                        canSort: false,
                    },
                    {
                        key: 'blotter_id',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.blotter_id',
                    },
                    {
                        key: 'parent_display_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-display-name',
                        canSort: true,
                    },
                    {
                        key: 'child_display_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-display-name',
                        canSort: true,
                    },
                    {
                        key: 'ccy_account_code',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.ccy-account-code',
                        canSort: true,
                    },
                    {
                        key: 'user_asset_class',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.asset-class',
                        canSort: true,
                    },
                    {
                        key: 'user_industry',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.sub-asset-class',
                        canSort: true,
                    },
                    {
                        key: 'user_geography',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.geography',
                        canSort: true,
                    },
                    {
                        key: 'custodian_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.custodian-name',
                        canSort: true,
                    },
                    {
                        key: 'traded_on',
                        type: 'date',
                        headerText: 'ui.mm.table-headers.traded_on',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        width: 100,
                        canSort: true,
                    },
                    {
                        key: 'settled_on',
                        type: 'date',
                        headerText: 'ui.mm.table-headers.settlement-date',
                        selectedByDefaultOn: ['desktop'],
                        width: 100,
                        canSort: true,
                    },
                    {
                        key: 'contract_currency',
                        type: 'text',
                        width: 80,
                        headerText: 'ui.mm.table-headers.contract-currency',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'transaction_type',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.transaction_type',
                        canSort: true,
                    },
                    {
                        key: 'trade_type',
                        type: 'text',
                        headerText: 'ui.table-header.trade-type',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                    },

                    {
                        key: 'trade_price',
                        type: 'amount',
                        width: 100,
                        headerText: 'ui.mm.table-headers.price',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'quantity',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.quantity',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'settlement_amount_ccy',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.settlement-amount',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'bank_narration',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.narration',
                    },

                    {
                        key: 'contract_type',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.contract_type',
                        canSort: true,
                    },
                    {
                        key: 'more_info',
                        type: 'object',
                        width: 150,
                        headerText: 'ui.mm.table-headers.more_info',
                        canSort: false,
                    },
                    {
                        key: 'additional_info',
                        type: 'object',
                        width: 150,
                        headerText: 'ui.mm.table-headers.additional_info',
                        canSort: false,
                    },
                ],
                per_page: 25,
                filterType: 'multi-level-filters',
                filterApi: 'filters/single-line-transactions',
                defaultSelection: 'trade_types',
                ga_event_name: 'Review All Transactions ',
            },
        },
    ],
};
